import type { FunctionComponent } from "react";

import { OvalUpperBackground } from "scmp-app/components/posties/content-homepage/oval-background";

import ImageLeftCar from "./img-left-car.png";
import ImageRightCarInTablet from "./img-right-car-in-tablet.png";
import ImageRightCar from "./img-right-car.png";
import {
  Container,
  ContentContainer,
  ImageLeftCarContainer,
  ImageRightCarContainer,
  ImageRightCarInTabletContainer,
  Wrapper,
} from "./styles";

// please refer to this commit if you want to restore the queue
export const SchoolOfTheWeek: FunctionComponent = () => (
  <Container>
    <ContentContainer>
      <Wrapper>
        <ImageLeftCarContainer>
          <img src={ImageLeftCar.src} />
        </ImageLeftCarContainer>
        <ImageRightCarContainer>
          <img src={ImageRightCar.src} />
        </ImageRightCarContainer>
        <ImageRightCarInTabletContainer>
          <img src={ImageRightCarInTablet.src} />
        </ImageRightCarInTabletContainer>
      </Wrapper>
    </ContentContainer>
    <OvalUpperBackground $ovalFillColor="#FFFFFF" $rectFillColor="#FCF5DE" />
  </Container>
);
SchoolOfTheWeek.displayName = "SchoolOfTheWeek";
